import {
    PLANOGRAM_OPTIONS_LOADING,
    GET_PLANOGRAM_OPTIONS_SUCCESS,
} from '../../actions/planogram-group/planogramOptions';

const INITIAL_STATE = {
    loading: false,
    options: [],
};

const planogramOptions = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PLANOGRAM_OPTIONS_LOADING:
            return { ...state, loading: true };
        case GET_PLANOGRAM_OPTIONS_SUCCESS:
            return { ...state, options: action.options, loading: false };
        default:
            return state;
    }
};
export default planogramOptions;
